module.exports = __webpack_public_path__ + "static/media/avicom-team.47f3f311.svg";